import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExportDialogComponent } from './export-dialog.component';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { ActionButtonModule } from '../action-button/action-button.module';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  declarations: [ExportDialogComponent],
  imports: [
    ActionButtonModule,
    CommonModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatInputModule,
    TranslateModule,
    MatOptionModule,
    MatSelectModule,
    SvgIconModule,
  ],
  exports: [ExportDialogComponent],
})
export class ExportDialogModule {}
